import apiService from '../apiService'
import { store } from 'store'
import {
  ROLE_ADMIN,
  // ROLE_BUYER_ADMIN USE WAIT API BUYER combined admin_buyer like auth/admin_buyer + auth/buyer to new api name
  ROLE_BUYER_ADMIN,
  ROLE_BUYER,
  ROLE_SUPPLIER,
} from 'store/role/constants'

export const authController = (configService = {}) => {
  const service = apiService(configService)
  const { role } = store.getState()
  // console.log('role', role)
  let apiPath = ''
  let apiPathVerify = ''
  switch (role) {
    case ROLE_BUYER_ADMIN:
      apiPath = '/auth/admin_buyer'
      break
    case ROLE_BUYER:
      apiPath = '/auth/buyer'
      apiPathVerify = '/cms/buyer'

      break
    case ROLE_SUPPLIER:
      apiPath = '/auth/supplier'
      apiPathVerify = '/cms/supplier'

      break
    case ROLE_ADMIN:
      apiPath = '/auth/admin'
      apiPathVerify = '/cms/admin'
      break
  }

  return {
    login: params => {
      return service.post({
        url: `${apiPath}/login`,
        params: params,
      })
    },

    getUser: (email = '') => {
      return service.getUser({
        url: `${apiPath}/user`,
      })
    },

    forgotPassword: mail => {
      return service.get({
        url: `${apiPath}/forgotPassword/${mail}`,
      })
    },

    getForgotPassword: mail => {
      return service.getForgotPassword({
        url: `${apiPath}/forgotPassword/${mail}`,
      })
    },

    activateEmail: email => {
      return service.get({
        url: `${apiPath}/activateMail/${email}`,
      })
    },

    setupPassword: params => {
      return service.put({
        url: `${apiPath}/setupPassword`,
        params: params,
      })
    },

    checkTokenExp: token => {
      return service.verifyToken({
        url: `${apiPathVerify}/verify?mail_key=${token}`,
        // token,
      })
    },

    checkAutoUpdate: (config = {}) => {
      return apiService(config).get({
        url: `/auth/buyer/checkAutoUpdate`,
      })
    },
  }
}
